import { beforeEqualToday, createValidator, ErrorObject, hora, range, required } from 'util/validation'

import AtestadoModel from '../components/model-atestado'
import { validateCpfCnsAtestado, validateDataAtestado } from '../validator-utils-atestado'

export const atestadoPadraoFormValidator = (possuiCpfCns: boolean, dataAtendimento: LocalDate | undefined) =>
  createValidator<AtestadoModel>(
    {
      data: [required, beforeEqualToday],
      hora: [required, hora],
      dias: [required, range(1, 999)],
    },
    (values: AtestadoModel, errors: ErrorObject<AtestadoModel>) => {
      validateDataAtestado(values, errors, dataAtendimento)
      validateCpfCnsAtestado(values, errors, possuiCpfCns)

      return errors
    }
  )
